import { ReactComponent as Rocket } from "./rocket.svg";
import { ReactComponent as Blogs } from "./blogs.svg";
import { ReactComponent as Settings } from "./setting.svg";
import { ReactComponent as PortfolioIcon } from "./portfolio.svg";
import { ReactComponent as JobsIcon } from "./jobs.svg";
import { ReactComponent as CalendarIcon } from "./calendar.svg";
import { ReactComponent as Calendar2 } from "./calendar-2.svg";
import { ReactComponent as CalendarBlank } from "./calendar-blank.svg";
import { ReactComponent as EducationIcon } from "./education.svg";
import { ReactComponent as PersonIcon } from "./person.svg";
import { ReactComponent as MentorIcon } from "./confirmation.svg";
import { ReactComponent as CoachesIcon } from "./coaches.svg";
import { ReactComponent as MenuIcon } from "./menu.svg";
import { ReactComponent as JobApplicationIcon } from "./job-applications.svg";
import { ReactComponent as Info } from "./info.svg";
import { ReactComponent as UpdateBlog } from "./update-blog.svg";
import { ReactComponent as Logout } from "./log-out.svg";
import { ReactComponent as ChevLeft } from "./chev-left.svg";
import { ReactComponent as ChevRight } from "./chev-right.svg";
import { ReactComponent as Mail } from "./mail.svg";
import { ReactComponent as Lock } from "./lock.svg";
import { ReactComponent as Eye } from "./eye.svg";
import { ReactComponent as EyeDisable } from "./eye-disable.svg";
import { ReactComponent as Hamburger } from "./hamburger.svg";
import { ReactComponent as DropDown } from "./dropDown.svg";
import { ReactComponent as Phone } from "./phone.svg";
import { ReactComponent as Cross } from "./cross.svg";
import { ReactComponent as Trash } from "./trash.svg";
import { ReactComponent as Search } from "./search.svg";
import { ReactComponent as ChevUp } from "./chev-up.svg";
import { ReactComponent as ChevDown } from "./chev-down.svg";
import { ReactComponent as TrashOutline } from "./trash-outline.svg";
import { ReactComponent as User } from "./user.svg";
import { ReactComponent as ArrowLeft } from "./arrow-left.svg";
import { ReactComponent as ArrowRight } from "./arrow-right.svg";
import { ReactComponent as ArrowUp } from "./arrow-up.svg";
import { ReactComponent as ArrowDown } from "./arrow-down.svg";
import { ReactComponent as Bell } from "./bell.svg";
import { ReactComponent as Plus } from "./plus.svg";
import { ReactComponent as Filter } from "./filter.svg";
import { ReactComponent as Pencil } from "./pencil.svg";
import { ReactComponent as TrashOutline2 } from "./trash-outline-2.svg";
import { ReactComponent as VerticalDots } from "./vertical-dots.svg";
import { ReactComponent as Tick } from "./tick.svg";
import { ReactComponent as ArrowRightOutline } from "./arrow-right-outline.svg";
import { ReactComponent as Download } from "./download.svg";
import { ReactComponent as Payment } from "./payment.svg";
import { ReactComponent as DashboardStats1 } from "./dashboard-stats-1.svg";
import { ReactComponent as DashboardStats2 } from "./dashboard-stats-2.svg";
import { ReactComponent as DashboardStats3 } from "./dashboard-stats-3.svg";
import { ReactComponent as Accept } from "./accept.svg";
import { ReactComponent as Reject } from "./reject.svg";
import { ReactComponent as CheckFilledLight } from "./check-filled-light.svg";
import { ReactComponent as CrossFilledLight } from "./cross-filled-light.svg";
import { ReactComponent as Clock } from "./clock.svg";
import { ReactComponent as MakeFellow } from "./make-fellow.svg";
import { ReactComponent as ReAssign } from "./reassign.svg";
import { ReactComponent as Teacher } from "./teacher.svg";
import { ReactComponent as Chat } from "./chat.svg";
import { ReactComponent as Check } from "./check.svg";
import { ReactComponent as Check2 } from "./check-2.svg";
import { ReactComponent as Images } from "./images.svg";
import { ReactComponent as PowerSellerRequest } from "./powerseller-request.svg";
import { ReactComponent as RegisterRequest } from "./register-request.svg";
import { ReactComponent as Testimonial } from "./testimonial.svg";
import { ReactComponent as Users } from "./users.svg";
import { ReactComponent as Bill } from "./bill.svg";
import { ReactComponent as FlagFill } from "./flag-fill.svg";
import { ReactComponent as FlagOutline } from "./flag-outline.svg";
import { ReactComponent as Tag } from "./tag.svg";
import { ReactComponent as Store } from "./store.svg";
import { ReactComponent as Order } from "./order.svg";
import { ReactComponent as Money } from "./money.svg";

const Icons = {
  Blogs,
  Settings,
  Info,
  UpdateBlog,
  Rocket,
  Logout,
  ChevLeft,
  ChevRight,
  Mail,
  Lock,
  Eye,
  EyeDisable,
  Hamburger,
  DropDown,
  Phone,
  Cross,
  Trash,
  Search,
  ChevUp,
  ChevDown,
  TrashOutline,
  User,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  Bell,
  Plus,
  Filter,
  Pencil,
  TrashOutline2,
  VerticalDots,
  Tick,
  ArrowRightOutline,
  Download,
  Payment,
  DashboardStats1,
  DashboardStats2,
  DashboardStats3,
  Accept,
  Reject,
  CheckFilledLight,
  CrossFilledLight,
  PortfolioIcon,
  JobsIcon,
  CalendarIcon,
  Calendar2,
  CalendarBlank,
  EducationIcon,
  PersonIcon,
  MentorIcon,
  MenuIcon,
  CoachesIcon,
  JobApplicationIcon,
  Clock,
  MakeFellow,
  ReAssign,
  Teacher,
  Chat,
  Check,
  Check2,
  Images,
  PowerSellerRequest,
  RegisterRequest,
  Users,
  Testimonial,
  Bill,
  FlagFill,
  FlagOutline,
  Tag,
  Store,
  Order,
  Money,
};

export { Icons };
